import { useState } from 'react';
import { LoanSearch } from "../../components";
import { fetchRequests } from '../../Requests/getRequests';
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken } from "../../slices/staffSlice";
import { authStaff } from '../../utils/constants';
import { show } from '../../slices/toastSlice';
import { useNavigate } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { Search01Icon } from '@hugeicons/core-free-icons';

function SearchLoan() {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [phone, setPhone] = useState("");
    const [loanState, setLoanState] = useState("");
    const [processing, setProcessing] = useState(false);
    const [searchedLoans, setSearchedLoans] = useState(null);

    const handleSearch = async (e) => {
        e.preventDefault();
        setProcessing(true);

        if (phone === "") {
            setProcessing(false);
            dispatch(show({ type: "error", state: true, message: "Please enter a phone number" }));
            return;
        }
        if (loanState === "") {
            setProcessing(false);
            dispatch(show({ type: "error", state: true, message: "Please select a loan state" }));
            return;
        }

        let res = await fetchRequests(`/loans/staff/search-loans`, "GET", authStaff(accessToken), { phone, state: loanState }, {});
        setProcessing(false);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }
        if (res?.err) {
            dispatch(show({ type: "error", state: true, message: `${res.message}` }));
            return;
        }

        dispatch(show({ type: "success", state: true, message: "Search successful" }));
        setSearchedLoans(res);
    };

    return (
        <div className='section-container md:py-2 py-0'>
            <div className='bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl shadow-sm p-6'>
                <div className='mb-5'>
                    <h2 className='text-base font-semibold text-gray-900 dark:text-gray-50'>Search Loans & Guarantors</h2>
                    <p className='text-sm text-gray-500 dark:text-gray-400 mt-0.5'>Find a loan by phone number and state.</p>
                </div>

                <form className='flex flex-wrap gap-3 items-end' onSubmit={handleSearch}>
                    <div className='flex-1 min-w-48'>
                        <label htmlFor="phoneNumber" className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">
                            Phone Number
                        </label>
                        <input
                            type="search"
                            name="phoneNumber"
                            id="phoneNumber"
                            className='form-input'
                            placeholder='e.g. 0244000000'
                            onChange={(e) => setPhone(e.target.value)}
                            required
                        />
                    </div>
                    <div className='flex-1 min-w-48'>
                        <label htmlFor="loan-filter" className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">
                            Loan State
                        </label>
                        <select
                            name="loan-filter"
                            id="loan-filter"
                            className='form-input'
                            required
                            onChange={(e) => setLoanState(e.target.value)}
                        >
                            <option value="">-- select --</option>
                            <option value="active">Active Loans</option>
                            <option value="completed">Completed Loans</option>
                            <option value="guarantors">Guarantors (Active Loans)</option>
                        </select>
                    </div>
                    <button
                        type="submit"
                        disabled={processing}
                        className='flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium text-white transition-colors disabled:opacity-60'
                        style={{ backgroundColor: '#1e3a6e' }}
                    >
                        <HugeiconsIcon icon={Search01Icon} size={16} />
                        {processing ? 'Searching…' : 'Search'}
                    </button>
                </form>

                {searchedLoans && (
                    <div className="mt-6">
                        <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3'>
                            {searchedLoans.length} result{searchedLoans.length !== 1 ? 's' : ''} found
                        </p>
                        {searchedLoans.length > 0 ? (
                            <div className='flex flex-col gap-2'>
                                {searchedLoans.map((loan, index) => (
                                    <LoanSearch key={index} loan={loan} />
                                ))}
                            </div>
                        ) : (
                            <p className='px-4 py-3 bg-gray-50 dark:bg-gray-900/50 border border-gray-100 dark:border-gray-700 rounded-lg text-sm text-gray-500'>
                                No loans found for that number.
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default SearchLoan;
